import { useMemo } from 'react';
import { useSeriesColor } from './useSeriesColor';

type BarChartDataset = {
  label: string;
  data: number[];
}[];

export const useBarChartParams = ({ xAxisLabels, dataset }: { xAxisLabels: string[]; dataset: BarChartDataset }) => {
  const bars = useMemo(() => {
    return dataset.map((dataItem) => ({
      label: dataItem.label,
      data: dataItem.data.map((value, index) => [xAxisLabels[index], value]) as [string, number][],
    }));
  }, [dataset, xAxisLabels]);

  const colorSet = useSeriesColor(dataset);

  return { bars, colorSet };
};
